import React from 'react';

type ContactBtnType = {
  children: React.ReactNode;
  backgroundColor: string;
};

const ContactBtn = ({
  children,
  backgroundColor = 'bg-slate-200',
}: ContactBtnType) => (
  <button
    type="button"
    className={`relative p-0.5  overflow-hidden text-sm rounded-lg group ${backgroundColor}`}
  >
    <span className="relative flex gap-2 justify-center items-center px-3 py-1.5 transition-all ease-in duration-75 bg-white dark:bg-deepBlack rounded-md group-hover:bg-opacity-0">
      {children}
    </span>
  </button>
);
export default ContactBtn;
